import React, { useState } from "react";
import interviewPrepImage from "../../Resources/Images/renaissanceIcon.svg"; // Update the path
import styles from "./renaissance.module.css"; // Create a new CSS module for Renaissance
import { NAV_LINK_CONSTANTS } from "../Header/NavLinksContants";

export default function RenaissanceHoverBox({ isMobileView = false }) {
    const handleExploreClick = () => {
        window.open(NAV_LINK_CONSTANTS.RENAISSANCE_COURSE_URL, "_blank");
    };

    // Function to disable scroll
    const disableScroll = () => {
        document.body.style.overflow = "hidden"; // Disable scrolling
    };

    // Function to enable scroll
    const enableScroll = () => {
        document.body.style.overflow = "auto"; // Enable scrolling
    };

    return (
        <div
            className={styles.renaissanceContainer}
            onClick={handleExploreClick}
            onMouseEnter={!isMobileView ? disableScroll : null}
            onMouseLeave={!isMobileView ? enableScroll : null}
        >
            <div className={styles.renaissanceText}>
                <div className={styles.renaissanceProgramTitle}>Renaissance</div>
                <div className={styles.interviewPrepLink}>Interview Preparation</div>
            </div>
            <div
                className={styles.hoverBox}
                onMouseEnter={!isMobileView ? disableScroll : null}
                onMouseLeave={!isMobileView ? enableScroll : null}
            >
                <h4>Ace Coding Interview:</h4>
                <p>Crack Top Tech Firms and Startups</p>
                <div className={styles.interviewImg}>
                    <img src={interviewPrepImage} alt="Ace Coding Interview" width={180} height={130} />
                </div>
                <div className={styles.hoverBoxButtons}>
                    <div className={styles.buttonDivOne}>
                        <button>All-in-One Learning</button>
                        <button>Personalized Mentoring</button>
                    </div>
                    <div className={styles.buttonDivTwo}>
                        <button>Mock Interviews</button>
                        <button>Self Paced</button>
                    </div>
                </div>
                <button className={styles.exploreProgramBtn}>Explore the Program</button>
            </div>
        </div>
    );
}
